export default {
  workshops: state => state.workshops,
  workshop: state => state.workshop,
  tickets: state => state.tickets,
  ticket: state => id => state.tickets.filter(ticket => ticket.id == id)[0],
  guestTicket: state => state.guestTicket,
  fibToken: state => state.fibToken,
}